// extracted by mini-css-extract-plugin
module.exports = {"detail-btn":"DetailBtn2_detail-btn__3Qcwr","detail-btn-icon":"DetailBtn2_detail-btn-icon__1gkAQ","normal":"DetailBtn2_normal__3KQS3","hover":"DetailBtn2_hover__3Gvqp"};